import styled, { css } from 'styled-components';

export const ToggleLogotypeRoot = styled.div<{ isExpanded: boolean }>`
  padding: 24px 18px 16px 18px;
  ${({ isExpanded }) =>
    isExpanded &&
    css`
      padding: 27px 20px 13px 20px;
    `}
`;

export const Logo = styled.img`
  height: 20px;
`;
